/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import { LinearProgress } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { Route, Switch, useRouteMatch, withRouter } from "react-router-dom";
import { branch, lifecycle, renderComponent, withHandlers } from "recompose";
import { bindActionCreators, compose } from "redux";
import {
  createCompanyPerson,
  deleteCompanyPerson,
  getCompanyPeople,
  getCompany
} from "../ducks/actions";
import {
  companyPeopleLoading,
  companyPeopleMember,
  isAuthenticated,
  isCompanyOwned,
  isCompanyPersonProposed,
  profile
} from "../ducks/selectors";
import { withNotifications } from "../notifications";
import TeamTab from "../shared/components/TeamTab";
import * as Messages from "./Messages";
import TeamAddDialog from "./TeamAddDialog";
import TeamEditDialog from "./TeamEditDialog";

const CompanyTeamTab = props => {
  const { path } = useRouteMatch();
  return (
    <>
      <TeamTab {...props} />
      <Switch>
        <Route path={`${path}/create`} component={TeamAddDialog} />
        <Route path={`${path}/:personId`} component={TeamEditDialog} />
      </Switch>
    </>
  );
};

const enhance = compose(
  withRouter,
  withNotifications,
  connect(
    (
      state,
      {
        match: {
          params: { id }
        }
      }
    ) => ({
      isAuthenticated: isAuthenticated(state),
      isCompanyOwned: isCompanyOwned({ companyId: id, state: "accepted" })(state),
      companyPeopleMember: companyPeopleMember(state),
      companyPeopleLoading: companyPeopleLoading(state),
      isCompanyPersonProposed: isCompanyPersonProposed(state),
      profile: profile(state)
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getCompanyPeople, deleteCompanyPerson, createCompanyPerson, getCompany },
        dispatch
      )
    })
  ),
  withHandlers({
    onCompanyPersonCreate: ({
      actions,
      match: {
        params: { id }
      },
      profile,
      ok,
      ko
    }) => async () => {
      try {
        await actions.createCompanyPerson({
          id,
          companyPerson: profile.person
            ? { person_id: profile.person.id }
            : {
                person_attributes: {
                  first_name: profile.first_name,
                  last_name: profile.last_name,
                  profile_id: profile.id
                }
              }
        });
        ok(Messages.CompanyUpdateSuccess);
      } catch (err) {
        ko(Messages.CompanyUpdateError);
      }
      await actions.getCompanyPeople({ id });
    },
    onCompanyPersonDelete: ({
      actions,
      match: {
        params: { id }
      },
      ok,
      ko
    }) => ({ person: companyPerson }) => async () => {
      try {
        await actions.deleteCompanyPerson({ id: companyPerson.id });
        await actions.getCompany({ id });
        ok(Messages.CompanyUpdateSuccess);
      } catch (err) {
        ko(Messages.CompanyUpdateError);
      }
      await actions.getCompanyPeople({ id });
    }
  }),
  lifecycle({
    async componentDidMount() {
      const {
        actions,
        match: {
          params: { id }
        }
      } = this.props;
      await actions.getCompanyPeople({ id });
    }
  }),
  branch(
    ({ companyPeopleLoading }) => companyPeopleLoading,
    renderComponent(() => <LinearProgress />)
  )
);

export default enhance(CompanyTeamTab);
